const MOBILE_LIMIT = 12;
const DESKTOP_BREAKPOINT = 1024;
const CARD_MIN_WIDTH = 84;
const CARD_GAP = 10;
const API_MAX_LIMIT = 50;

// CSS'teki `repeat(auto-fill, minmax(84px, 1fr))` hesabının veri karşılığı.
// Telefonda mevcut 12 oyun korunur; masaüstünde tek satırı tam dolduracak
// kadar oyun istenir. API tavanı da burada aşılmaz.
export const resolveVegaShortcutLimit = (viewportWidth, stripWidth) => {
  if (viewportWidth < DESKTOP_BREAKPOINT || stripWidth <= 0) {
    return MOBILE_LIMIT;
  }
  const columns = Math.floor((stripWidth + CARD_GAP) / (
    CARD_MIN_WIDTH + CARD_GAP
  ));
  return Math.min(API_MAX_LIMIT, Math.max(1, columns));
};
